import {LanguageEnum} from 'src/enums';
import * as Yup from 'yup';

export interface CreateCompanyFormType {
    businessId: number;
    companyName: string;
    billingEmail?: string;
    language: LanguageEnum;
    loginEmail: string;
    billingAddressCity: string;
    billingAddressCountry: string;
    billingAddressHouseNumber: string;
    billingAddressParkingPlace: string;
    billingAddressRegion: string;
    billingAddressStreet: string;
    billingAddressZipCode: string;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    contactPersonPhone: string;
    parkingAddressCity: string;
    parkingAddressCountry: string;
    parkingAddressHouseNumber: string;
    parkingAddressParkingPlace: string;
    parkingAddressRegion: string;
    parkingAddressStreet: string;
    parkingAddressZipCode: string;
    isParkingAddressSameAsBillingAddress: boolean;
    chargeConsumption: boolean;
}

export interface EditCompanyFormType
    extends Omit<
        CreateCompanyFormType,
        | 'loginEmail'
        | 'isParkingAddressSameAsBillingAddress'
        | 'billingAddressParkingPlace'
        | 'parkingAddressCity'
        | 'parkingAddressCountry'
        | 'parkingAddressHouseNumber'
        | 'parkingAddressParkingPlace'
        | 'parkingAddressRegion'
        | 'parkingAddressStreet'
        | 'parkingAddressZipCode'
    > {
    businessId: number;
    companyName: string;
    billingEmail?: string;
    billingAddressCountry: string;
    billingAddressRegion: string;
    billingAddressCity: string;
    billingAddressStreet: string;
    billingAddressHouseNumber: string;
    billingAddressZipCode: string;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    contactPersonPhone: string;
}

export const companyFormSchema = Yup.object().shape({
    companyName: Yup.string().max(255).required('schemaRequiredCompanyName'),
    billingEmail: Yup.string().email('schemaValidEmail').max(255),
    loginEmail: Yup.string().email('schemaValidEmail').max(255).required('schemaRequiredEmail'),
    billingAddressHouseNumber: Yup.string().required('schemaRequiredHouseNumber'),
    billingAddressStreet: Yup.string().max(255).required('schemaRequiredStreet'),
    billingAddressCity: Yup.string().required('schemaRequiredCity'),
    billingAddressZipCode: Yup.string().max(255).required('schemaRequiredZip'),
    billingAddressCountry: Yup.string().required('schemaRequiredCountry'),
    billingAddressRegion: Yup.string().required('schemaRequiredRegion'),
    language: Yup.string().required('schemaLanguageRequired'),
    contactPersonFirstName: Yup.string().max(255).required('schemaRequiredFirstName'),
    contactPersonLastName: Yup.string().max(255).required('schemaRequiredLastName'),
    isParkingAddressSameAsBillingAddress: Yup.boolean(),
    chargeConsumption: Yup.boolean(),
    parkingAddressCity: Yup.string().required('schemaRequiredCity'),
    parkingAddressCountry: Yup.string().required('schemaRequiredCountry'),
    parkingAddressHouseNumber: Yup.string().required('schemaRequiredHouseNumber'),
    parkingAddressRegion: Yup.string().required('schemaRequiredRegion'),
    parkingAddressStreet: Yup.string().max(255).required('schemaRequiredStreet'),
    parkingAddressZipCode: Yup.string().max(255).required('schemaRequiredZip'),
    parkingAddressParkingPlace: Yup.string().max(255),
    billingAddressParkingPlace: Yup.string().max(255),
    contactPersonPhone: Yup.string().max(255).required('schemaRequiredPhone'),
});
